import { formatLargeNumber } from 'Utils/formatters';
import { cn } from 'Utils/cn';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function SubscriptionPaymentFailedDialogPlanCard(props) {
    const { title, limit, image, className } = props;
    const { t } = useTranslation('common');

    return (
        <div className="bg-white rounded-2xl p-6 shadow-xl max-w-3xs w-full">
            <div className="flex justify-between items-start mb-2">
                <img src={image} height={80} width={80} alt="" className="size-14" />

                <div className="shrink-0 font-semibold text-white flex items-center py-1 px-2 rounded-sm bg-[#6050C6] uppercase text-2xs tracking-wider">
                    {t('current-plan')}
                </div>
            </div>
            <div className="mb-3">
                <span
                    className={cn(
                        'inline-block font-display font-bold tracking-tight text-xl bg-gradient-to-r from-[#bc2ab4] to-[#5370f5] bg-clip-text text-transparent',
                        className,
                    )}
                >
                    {title}
                </span>
            </div>
            <div className="py-6">
                <span className="text-gray-500 text-md">{t('blocked-card-description-1')}</span>{' '}
                <span className="text-[#FF7F5B] font-semibold underline underline-offset-3">
                    <span className="text-dark-blue">
                        {t('blocked-card-description-2', { limit: formatLargeNumber(limit) })}
                    </span>
                </span>
            </div>
        </div>
    );
}

SubscriptionPaymentFailedDialogPlanCard.propTypes = {
    title: PropTypes.string.isRequired,
    limit: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired,
    className: PropTypes.string,
};
